export enum CustomAttributesTypes {
  TEXT = 'TEXT',
  SINGLE_SELECT = 'SINGLE_SELECT',
  MULTI_SELECT = 'MULTI_SELECT'
}

export enum FilterFacetsTypes {
  BOOLEAN = 'BOOLEAN'
}

type CustomAttributeTypeMap = {
  [CustomAttributesTypes.TEXT]: string;
  [CustomAttributesTypes.SINGLE_SELECT]: string;
  [CustomAttributesTypes.MULTI_SELECT]: string;
};
export interface CustomAttributeProps<K extends CustomAttributesTypes> {
  name: string;
  type: K;
  key: string;
  spec: any;
  required: boolean;
  filterable: boolean;
  value: CustomAttributeTypeMap[K];
}
export type UnionCustomAttributeProps =
  | CustomAttributeProps<CustomAttributesTypes.TEXT>
  | CustomAttributeProps<CustomAttributesTypes.SINGLE_SELECT>
  | CustomAttributeProps<CustomAttributesTypes.MULTI_SELECT>;

export type SingleSelectValue = {
  key: string;
  label: string;
  color_code?: string;
};
export type MultiSelectValue = {
  key: string;
  label: string;
}[];

export type CustomAttribute =
  | { type: CustomAttributesTypes.TEXT; value: string }
  | {
      type: CustomAttributesTypes.SINGLE_SELECT;
      value: SingleSelectValue;
    }
  | { type: CustomAttributesTypes.MULTI_SELECT; value: MultiSelectValue };

export type CustomAttributeValue =
  | string
  | SingleSelectValue
  | MultiSelectValue;

export enum CustomAttributeEntity {
  PRODUCT = 'products',
  COMPANY = 'companies'
}
